<ng-content select="sd-accordion-label"></ng-content>
<ng-content select="sd-accordion-content" *ngIf="isOpened()"></ng-content>
